import React from 'react'
import classNames from 'classnames'

import { Heading, Image, Paragraph } from '@scentregroup/ui'
import Grid from '../grid'
import { SGFeaturedLink } from '../../../types/featured-link'
import { Link as LinkType } from '../../../types/link'

import style from './index.module.scss'

const SQUARE_THRESHOLD = 4

interface FeaturedLinksGridTrackers {
  clicked?: (label: string) => void
}

export const FeaturedLinksGrid: React.FC<{
  Link: LinkType
  featuredLinks: Array<SGFeaturedLink>
  itemsPerRow: number
  title: string
  className?: string
  square?: boolean
  trackers?: FeaturedLinksGridTrackers
}> = ({
  Link,
  featuredLinks,
  itemsPerRow,
  title,
  className,
  square = itemsPerRow >= SQUARE_THRESHOLD,
  trackers,
}) => {
  const ratio = square ? 'square' : 'standard'
  return (
    <div className={classNames(style.FeaturedLinksGrid, className)}>
      {title && (
        <Heading type="small" className={style.heading}>
          {title}
        </Heading>
      )}
      <Grid itemsPerRow={itemsPerRow}>
        {featuredLinks.map(featuredLink => (
          <Link
            to={featuredLink.url}
            key={`${featuredLink.imageUrl}-${featuredLink.title}-${featuredLink.url}`}
            className={style.FeaturedLink}
            data-test-id="featured-links-grid"
            onClick={() => trackers?.clicked?.(featuredLink.title)}
          >
            <Image
              imageUrl={featuredLink.imageUrl}
              className={style.image}
              ratio={ratio}
              bgSize="cover"
              type="mobile"
            />
            <Paragraph className={style.paragraph}>
              {featuredLink.title}
            </Paragraph>
          </Link>
        ))}
      </Grid>
    </div>
  )
}
